<template>
  <div class="hot-brand-list" ref="hot">
    <div class="item" :class="{ active: !brand.pcauto_id }" @click="selectItem({})">全部</div>
    <div
      @click="selectItem(item)"
      v-for="(item, index) in hotBrandList"
      :key="index"
      :class="{ active: brand.pcauto_id === item.pcauto_id }"
      class="item"
    >
      {{ item.name }}
    </div>
    <div class="item" @click="clickMore" :class="{ active: isMore }">更多</div>
  </div>
</template>
<script>
export default {
  name: 'hot-brand-list',
  props: {
    brand: {
      type: Object,
      default() {
        return {};
      },
    },
    hotBrandList: {
      type: Array,
      default() {
        return [];
      },
    },
    isMore: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    selectItem(item) {
      this.$emit('selectItem', { pcauto_id: item.pcauto_id, name: item.name });
    },
    clickMore() {
      this.$emit('clickMore');
    },
  },
};
</script>
<style lang="scss" scoped>
.hot-brand-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto;
  font-size: 30px;
  .item {
    white-space: nowrap;
    width: 22%;
    height: 55px;
    line-height: 55px;
    text-align: center;
    box-sizing: border-box;
    margin-bottom: 20px;
    padding: 0 5px;
    color: #ffffff;
    background: url(~@this/assets/image-03.png) no-repeat;
    background-size: 100% 100%;
    &.active {
      background: url(~@this/assets/image-02.png) no-repeat;
      background-size: 100% 100%;
      color: #db1a24;
    }
  }
}
</style>
